import { render, staticRenderFns } from "./CompanyProjectsView.vue?vue&type=template&id=44265388&scoped=true"
import script from "./CompanyProjectsView.vue?vue&type=script&lang=js"
export * from "./CompanyProjectsView.vue?vue&type=script&lang=js"
import style0 from "./CompanyProjectsView.vue?vue&type=style&index=0&id=44265388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44265388",
  null
  
)

export default component.exports